import { findUISchema } from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { Stack } from "@certn/cascadia";
import { ExpandableCard } from "@certn/cascadia-react";
import { css } from "@emotion/css";

import { useItemHeadingText } from "../ItemHeading/utils";
import { ItemProps } from "../types";
import { ItemSubtitle } from "../ItemSubtitle";
import { useExpandable } from "../../expandable-context";
import { useEffect, useState } from "react";

export function CardSummary(props: ItemProps) {
  const headingText = useItemHeadingText(
    props.index,
    props.label,
    props.minItems,
    props.uischema,
    props.path
  );
  const [desiredExpandedState, setDesiredExpandedState] = useState(
    props.isOpen
  );
  const { expandable } = useExpandable();
  const itemSchema = findUISchema(
    props.uischemas || [],
    props.schema,
    props.uischema.scope,
    props.path,
    undefined,
    props.uischema,
    props.rootSchema
  );

  useEffect(() => {
    setDesiredExpandedState(props.isOpen);
  }, [props.isOpen]);

  return (
    <ExpandableCard
      title={headingText || ""}
      titleStyle={props.uischema?.options?.titleStyle}
      subtitle={<ItemSubtitle {...props} />}
      cardStyles={props.uischema?.options?.cardStyles}
      expanded={desiredExpandedState}
      expandable={expandable}
    >
      <div className={styles.cardContent}>
        <Stack gap="space-4">
          <JsonFormsDispatch
            schema={props.schema}
            uischema={itemSchema}
            path={props.path}
          />
        </Stack>
      </div>
    </ExpandableCard>
  );
}

const styles = {
  cardContent: css({
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
  }),
};
